module.exports = __webpack_public_path__ + "assets/images/equipe_title.e68562c59cb11d39b12997bb3be734e4.png";